import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const EyeHidden = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.53 9.46992L9.46995 14.5299M14.53 9.46992C13.88 8.81992 12.99 8.41992 12 8.41992C10.02 8.41992 8.41995 10.0199 8.41995 11.9999C8.41995 12.9899 8.81995 13.8799 9.46995 14.5299M14.53 9.46992L21.9998 1.99997M9.46995 14.5299L2 21.9998M17.8199 5.76995C16.0699 4.44995 14.0699 3.72995 11.9999 3.72995C8.46987 3.72995 5.17987 5.80995 2.88987 9.40995C1.98987 10.8199 1.98987 13.19 2.88987 14.6C3.67987 15.84 4.59987 16.91 5.59987 17.77M8.41995 19.5302C9.55995 20.0102 10.77 20.2702 12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C20.78 8.88021 20.42 8.39021 20.05 7.93021M15.51 12.7002C15.25 14.1102 14.1 15.2602 12.69 15.5202",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
